<script setup lang="ts">
import { computed, inject, onMounted, ref, watch } from "vue";
import { useConfigurationsStore } from "../../../../stores";

interface ProfessionalQualificationForm {
  name: string | null
  professionalBodyId: string | null
  professionalQualificationId?: string | null
}

interface ProfessionalBody {
  id: string
  name: string
}

interface DraftData {
  id: string
  name: string
  professionalBodyId: string
}

const props = defineProps<{
  draftData: DraftData | null
}>()

const store = useConfigurationsStore();
const successToast = inject<any>('successToast')
const errorToast = inject<any>('errorToast')

const form = ref<ProfessionalQualificationForm>({
  name: null,
  professionalBodyId: null
})
const spinner = ref(false)
const professional_bodies = ref<ProfessionalBody[]>([])

const professionalQualification = computed(() => store.professionalQualification);
const insolvencyError = computed(() => store.insolvencyError);
const professionalBodies = computed(() => store.professionalBodies);

const addBody = () => {
  spinner.value = true
  store.updateProfessionalQualification(form.value);
}

onMounted(() => {
  store.fetchProfessionalBodies();
  if (props.draftData) {
    form.value.name = props.draftData.name
    form.value.professionalBodyId = props.draftData.professionalBodyId
    form.value.professionalQualificationId = props.draftData.id
  }
})

watch(professionalQualification, () => {
  spinner.value = false
  store.fetchProfessionalQualifications();
  successToast?.('Success', 'Professional Qualification updated successfully')
})

watch(insolvencyError, () => {
  spinner.value = false
  errorToast?.('Error', 'An error occurred while updating professional qualification')
})

watch(professionalBodies, (data) => {
  if (data?.data) {
    professional_bodies.value = data.data
  }
})
</script>

<template>
  <div class="p-4">
    <div class="space-y-4">
      <div>
        <label class="text-xs font-semibold text-gray-600 uppercase tracking-wide">Name</label>
        <input
          type="text"
          v-model="form.name"
          class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-gray-50"
          placeholder="e.g. Bachelors"
          required
        />
      </div>

      <div>
        <label class="text-xs font-semibold text-gray-600 uppercase tracking-wide">Professional Body</label>
        <select
          v-model="form.professionalBodyId"
          class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary"
        >
          <option value="" disabled>Select a professional body</option>
          <option v-for="pb in professional_bodies" :key="pb.id" :value="pb.id">
            {{ pb.name }}
          </option>
        </select>
      </div>

      <div class="flex justify-end gap-2">
        <button
          @click="addBody"
          :disabled="spinner"
          class="btn-primary"
        >
          <span>Save</span>
        </button>
      </div>
    </div>
  </div>
</template>
